import { domain_vizr } from "../../redux/constants/constants";

export const SET_MDR_DASHBOARD_FROM_TIME_STAMP = "SET_MDR_DASHBOARD_FROM_TIME_STAMP";
export const SET_MDR_DASHBOARD_TO_TIME_STAMP = "SET_MDR_DASHBOARD_TO_TIME_STAMP";
export const GET_MDR_DASHBOARD_OVERVIEW_COUNT = "GET_MDR_DASHBOARD_OVERVIEW_COUNT";
export const SET_MDR_DASHBOARD_OVERVIEW_COUNT = "SET_MDR_DASHBOARD_OVERVIEW_COUNT";
export const MDR_DASHBOARD_LOADER = "MDR_DASHBOARD_LOADER";
export const getDashboardOverviewCount = (startDate, endDate) => {
    return `${domain_vizr}/jira/threatInsight/incidents/count?endDate=${endDate}&startDate=${startDate}`
}
export const getIncidentList = () => {
    return `${domain_vizr}/jira/threatInsight/incidents/types`
};
export const GET_MDR_DASHBOARD_INCIDENT_LIST = "GET_MDR_DASHBOARD_INCIDENT_LIST";
export const SET_MDR_DASHBOARD_INCIDENT_LIST = "SET_MDR_DASHBOARD_INCIDENT_LIST";
export const getIncidentSummary = (startDate, endDate) => {
    return `${domain_vizr}/jira/threatInsight/incidents/summary?endDate=${endDate}&startDate=${startDate}`
}
export const GET_MDR_DASHBOARD_INCIDENT_SUMMARY = "GET_MDR_DASHBOARD_INCIDENT_SUMMARY";
export const SET_MDR_DASHBOARD_INCIDENT_SUMMARY = "SET_MDR_DASHBOARD_INCIDENT_SUMMARY";
export const SET_SELECTED_INCIDENT = "SET_SELECTED_INCIDENT";
export const GET_MDR_DASHBOARD_ALL = "GET_MDR_DASHBOARD_ALL";
export const FETCH_CUBE_INCIDENT_TABLE = "FETCH_CUBE_INCIDENT_TABLE";
export const SET_INCIDENT_TABLE_DATA = "SET_INCIDENT_TABLE_DATA";
export const SET_INCIDENT_TABLE_LOADER = "SET_INCIDENT_TABLE_LOADER";
export const CLEAR_SELECTED_INCIDENT = "CLEAR_SELECTED_INCIDENT";
export const CHART_FILTERED_LIST = "CHART_FILTERED_LIST";

export const GET_TABLE_DATA_JIRA = "GET_TABLE_DATA_JIRA";
export const SET_TABLE_DATA_JIRA = "SET_TABLE_DATA_JIRA";
export const fetchTableDataJira = (startDate, endDate, size, queryParam) => {
    return `${domain_vizr}/jira/threatInsight/incidents/tableData?endDate=${endDate}&startDate=${startDate}&size=${size}&${queryParam}`
};
export const SET_JIRA_INCIDENT_TABLE_LOADER = "SET_JIRA_INCIDENT_TABLE_LOADER";
export const SET_JIRA_INCIDENT_TABLE_FILTER = "SET_JIRA_INCIDENT_TABLE_FILTER";
export const SET_JIRA_INCIDENT_TABLE_FILTER_OPTIONS = "SET_JIRA_INCIDENT_TABLE_FILTER_OPTIONS";
export const jiraTableHeaders = ["ticketId", "incidentId", "incidentStatus",];
export const CLEAR_JIRA_INCIDENT_TABLE_FILTERS = "CLEAR_JIRA_INCIDENT_TABLE_FILTERS";
